"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChannel = void 0;
const topic_1 = require("../../topic");
const TRACKING_CHANNEL = "tracking";
class TrackingChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = TRACKING_CHANNEL;
        this.topics = {
            sendEvent: new topic_1.Topic('sendEvent', TRACKING_CHANNEL, this._logger),
            sendAnalytics: new topic_1.Topic('sendAnalytics', TRACKING_CHANNEL, this._logger),
        };
    }
}
exports.TrackingChannel = TrackingChannel;
//# sourceMappingURL=tracking.channel.js.map